import { ComplaintRequestPayload } from './types';
import { useSmartMutation } from '@shared/api/queries/hooks';
import { complaintApis } from './api';
import { queryClient } from '@shared/api/queries/queryClient';

export const useCreateBulkComplaintRequests = () => {
  return useSmartMutation(
    (data: any): Promise<any> => complaintApis.createBulkComplaintRequest(data),
    {
            onSuccess: () => {
                queryClient.refetchQueries({ queryKey: ["cx", "consumerRequests", "list"] });
            }
        }
  );
};

export const useCreateSingleComplaintRequests = () => {
  return useSmartMutation(
    (data: any): Promise<any> => complaintApis.createSingleComplaintRequest(data),
    {
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["cx", "consumerRequests", "list"] });
        }
    }
  );
};
